export const PROFESSIONAL_DELIVERY = 'delivery'
export const DOORWAY_DELIVERY = 'doorway'
export const PICK_UP = 'pickup'
